module.exports = __webpack_public_path__ + "static/media/3-copy.e6e6b359.svg";